import { connect } from 'react-redux';
import Liquidate from './Liquidate';
import timeDepositActions from '../../../../store/actions/timeDeposit.action';

const mapStateToProps = state => ({
  timeDeposit: state.timeDeposit.timeDeposit,
  email: state.user.email,
  accounts: state.account.list,
  account: state.liquidate.account,
  completed: state.liquidate.completed,
  timeDepositLiquidate: state.liquidate.timeDepositLiquidate
});

const mapDispatchToProps = dispatch => {
  return {
    getTimeDeposit: id => {
      dispatch(timeDepositActions.getTimeDeposit(id));
    },
    cleanLiquidate: () => {
      dispatch(timeDepositActions.cleanLiquidate());
    },
    getConfiguracionDap: ()=> dispatch(timeDepositActions.getConfiguracionDap())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Liquidate);
